export enum LoggerLevelEnum {
  OFF = 0, // mode prod (console OFF)
  TRACE = 1, // console.trace with timestamp
  DEBUG = 2, // console.log with timestamp
  INFO = 3, // console.log
  LOG = 4, // console.log
  WARN = 5, // console.warn with timestamp
  ERROR = 6, // console.error with timestamp
  FATAL = 7, // console.error with timestamp,
  DISPLAY = 8, // console.error with timestamp,
  ALL = 99, // console.error with timestamp
}

export enum LoggerEventListenerEnum {
  CONSOLE_LOG = 'consoleLog',
  LOCAL_STORAGE_LOG = 'localStorageLog',
  DEXIE_LOG = 'dexieLog',
}

export class LoggerLevelEnumTools {
  static toNumber(level: string): LoggerLevelEnum {
    const numbers = Object.keys(LoggerLevelEnum).filter(
      (k) => k.toLowerCase() === level.toLowerCase(),
    );
    if (numbers.length) {
      return LoggerLevelEnum[numbers[0]];
    } else {
      return LoggerLevelEnum.OFF;
    }
  }
}
